export default __webpack_public_path__ + "static/media/minha-encomenda-integracao-min.a0dc108d.png";